<div *ngIf="!isReadOnly; else readOnly">
  <div fxLayout="column" class="coverage-price-container">
    <div class="title" fxLayout="column">{{'calculator.insurancePrice' | translate}}</div>
    <div class="divider"></div>
    <div *ngIf="quotation$ | async as quotation; else waitingQuote">
      <div class="price" fxLayout="row" fxLayoutAlign="center end"><div class="price-number">{{ quotation.primaTotal | currency: 0 : ' ' }}</div>{{'calculator.currencyPerYear' | translate}}</div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button class="contract-button" (click)="goToContract()">{{'calculator.contractButton' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<!-- Template para mostrar si se quiere un "esperando cotizacion" o algo parecido -->
<ng-template #waitingQuote>
    <div>
      <div class="price" fxLayout="row" fxLayoutAlign="center end">
        <div style="font-size: 1rem;">_____</div>
        {{'calculator.currencyPerYear' | translate}}
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <span style="text-align: center;">{{ 'calculator.quote_content.no_quote' | translate }}</span>
      </div>
    </div>
</ng-template>

<ng-template #readOnly class="readOnly">
  <div fxLayout="column" class="coverage-price-container-readOnly">
    <div class="title-readOnly" fxLayout="column">{{'calculator.insurancePrice' | translate}}</div>
    <div class="divider-readOnly"></div>
    <div class="price-readOnly" fxLayout="row" fxLayoutAlign="end end">
        <div class="price-number-readOnly" *ngIf="!priceContract && quotation$ | async as quotation">
          {{quotation.primaTotal | currency: 0 : ' '}}
        </div>
        <div *ngIf="priceContract" class="price-number-readOnly">
          {{priceContract | currency: 0 : ' '}}
        </div>
      {{'calculator.currencyPerYear' | translate}}
    </div>
  </div>
</ng-template>